import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { QnalistPage } from './qnalist';

@NgModule({
  declarations: [
    QnalistPage,
  ],
  imports: [
    IonicPageModule.forChild(QnalistPage),
  ],
})
export class QnalistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/qnalist/qnalist.module.ts